export default __webpack_public_path__ + "static/media/web1.3508b8df.png";